// style
import "./ProfileItem.scss";

import colorSchema from "../../../assets/kits/colors";

export default function ProfileItem({
  title,
  description,
  mainIcon,
  moreIcon,
}) {
  return (
    <div className="d-flex align-items-center  profile-item w-100">
      <div className="d-flex align-items-center justify-content-center main-icon">
        {mainIcon}
      </div>
      <div className="text flex-grow-1 d-flex flex-column  mr-x-12">
        {title != "" && (
          <div
            className="title-h5-m flex-grow-1"
            style={{ color: colorSchema.foreground_background_he }}
          >
            {title}
          </div>
        )}
        {description != "" && (
          <div
            className="desc-l flex-grow-1"
            style={{ color: colorSchema.foreground_background_me }}
          >
            {description}
          </div>
        )}
      </div>
      <div className="more-icon">{moreIcon}</div>
    </div>
  );
}
